/** EN uses Swedish values until translated. */
export const newsTranslationsEn = {
    noRows: 'No news matching the last 14 days',
    headlines: {
        cancellation: {
            nonCash: '{{companyName}} {{issueType}} of {{consideration}} was not carried out',
            default: '{{companyName}} {{issueType}} was not carried out',
        },
        newCommitments: {
            warrant: '{{companyName}} has received commitments for the exercise of {{name}}',
            issue: '{{companyName}} {{issueType}} has received additional commitments',
        },
        publication: {
            noTermsInitially: '{{companyName}} publishes an {{issueType}} (terms to follow)',
            guarantorFeeIssue: '{{companyName}} carries out a set-off issue regarding {{issueType}}',
            announces: '{{companyName}} announces an {{issueType}}',
            approxAmount: 'of {{amount}}',
            approxShares: 'of {{units}} shares',
            ipoWithPrice: '{{companyName}} announces details regarding an IPO of approx {{amount}}',
            ipoWithInterval: '{{companyName}} announces details regarding an IPO of approx {{amountLow}} - {{amountHigh}}',
            warrant: '{{companyName}} issues {{listedPrefix}}warrants of series {{name}}',
            warrantUnlisted: 'unlisted',
            convertibleCreditLine: '{{companyName}} entered into a credit facility with convertible loans of {{amount}}',
            convertibleLoan: '{{companyName}} raises {{amount}} through a convertible loan',
            warrantsOnly: 'with warrants only',
            securedTo: 'secured to {{rate}}',
            regardingNonCash: 'regarding {{consideration}}',
        },
        terms: {
            warrant: '{{companyName}} announces sub price {{price}} {{currency}} for {{name}}',
            issue: '{{companyName}} announces terms of previously announced {{issueType}}',
        },
        outcome: {
            preliminary: '{{companyName}} preliminary outcome: Subscription rate {{rate}}',
            final: '{{companyName}} outcome: Subscription rate {{rate}}',
            guarantorShare: 'where guarantors subscribed for {{share}} of the subscribed shares',
            abbDirected: '{{companyName}} carried out an {{issueType}} at a sub price of {{price}} and raised {{amount}}',
            ipo: 'Outcome in {{companyName}} IPO: Subscription rate {{rate}}',
            warrant: '{{companyName}} outcome in option exercise for series {{name}}: Sub rate {{rate}}',
        },
        prospectus: {
            document: '{{companyName}} {{documentType}} is now available',
            prospectus: 'prospectus',
            informationDocument: 'information document',
        },
        conversion: {
            toShares: '{{companyName}} approximately {{amount}} converted to shares',
        },
    },
}

export const newsEventTypeEn = {
    cancellation: 'Cancelled',
    newCommitments: 'New commitments',
    guarantorCompensation: 'Issue to guarantors',
    publication: 'Publication',
    prospectus: 'Prospectus',
    outcome: 'Outcome',
    terms: 'Terms',
    conversion: 'Conversion',
}
